import React, { useState, useCallback, useEffect } from "react";
import { InsuranceRequirement, JonesRecord, Project, PermissionOptionModel, CoiContact, InsuranceSettingModel } from "../../models"
import API from "../../apis";
import fileDownload from 'js-file-download';
import { showErrorMessage, showSuccessMessage } from "../../utils";
import SuccessIcon from "../../shared/SuccessIcon";
import { ValidateToken } from "../../shared/hooks";
import { useHistory } from "react-router";

const initialCoiContact: CoiContact = {
  primaryContact: "",
  primaryContactError: "",

  additionalContact1: "",
  additionalContact1Error: "",

  additionalContact2: "",
  additionalContact2Error: "",

  additionalContact3: "",
  additionalContact3Error: "",

  additionalContact4: "",
  additionalContact4Error: "",
  insuranceRequestId:0,
  recordName:"",
};

const initialSetting: InsuranceSettingModel = {
  isContactUpdateEnabled: false
}

export function useLoad() {
  const [jonesVendor, setJonesVendor] = useState<JonesRecord[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [downloading, setDownLoading] = React.useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingJonesVendors, setLoadingJonesVendors] = useState(false);
  const [permissions, setPermissions] = useState<PermissionOptionModel[]>([])
  const [Coifileload, setCoifileload] = useState<boolean>(false);
  const [jonesGlobalVendor, setJonesGlobalVendor] = useState<JonesRecord[]>([]);
  const [loadingGlobalJonesVendors, setLoadingGlobalJonesVendors] = useState(false);
  const [isGlobalexits, setisGlobalexits] = useState(false);
  const [isGlobalViewEnable, setIsGlobalViewEnable] = useState(false);
  const [JonesPermission, setJonesPermission] = useState<boolean>(false);
  const [coiContact, setCoiContact] = useState<CoiContact>(initialCoiContact);
  const [insuranceSetting, setInsuranceSetting] = useState<InsuranceSettingModel>(initialSetting);
  const [originalCoiContact, setOriginalCoiContact] =
  useState<CoiContact>(initialCoiContact);
  const [submittingContacts, setSubmittingContacts] = useState<boolean>(false);
  const [loadingContacts, setLoadingContacts] = useState(false);
  const history = useHistory();

  React.useEffect(() => {
    let isValid = ValidateToken(history);
    if (!isValid) {
      return;
    }
  }, [history]);



  const [project, setProject] = useState<Project>({
    id: 0,
    name: "",
    code: "",
    vendorList: [],
    requirementList: [],
    projectRoles: [],
    clientId: 0,
    kriyagoProjectId: 0,
    requirements: [],
    logeduser: "",
    comanyAccName:"",
  });

  const [insurance, setInsurance] = useState<InsuranceRequirement>({
    vendors: [],
    projectId: 0,
    requirementId: null,
    clientId: 0,
    kriyagoProjectId: 0,
    companyId: '0',
    tabId: 0,
  });


  const onLoadProject = useCallback(async () => {
    setLoading(true);
    try {
      let projectId = new URLSearchParams(window.location.search).get(
        "ProjectID"
      );
      let companyId = new URLSearchParams(window.location.search).get(
        "CompanyID"
      );

      const response = await API.get(
        `Procore/GetProject?ProjectID=${projectId}&CompanyID=${companyId?.toString()}`
      );
      if (response && response.data) {
        const data = {
          ...response.data,
          vendorList: [
            // {
            //   id: "0",
            //   name: "Select Alyl",
            //   code: "Select All",
            //   emailAddress: "",
            //   isSkip: false,
            //   projectUsers: [],
            //   isRequestSent: false,
            // },
            ...response.data.vendorList,
          ],
        };
        setProject(data);

        setInsurance((insurance: any) => {
          return {
            ...insurance,
            projectId: response.data ? response.data.id : 0,
            clientId: response.data ? response.data?.clientId : 0,
            vendors: [],
            kriyagoProjectId: response.data ? response.data?.kriyagoProjectId : 0,
            companyId: companyId ? companyId?.toString() : '0'
          };
        });
      } else {
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setErrorMessage(e.message);
    }

    setLoading(false);
  }, []);

  const onLoadVendorsUsers = useCallback(
    async (companyId: string, vendorIds: Array<string>) => {
      setLoadingUsers(true);
      try {
        const data = {
          companyId: companyId,
          vendors: vendorIds,
        }
        const response = await API.post(
          `Procore/GetVendorUsers`,
          data
        );


        setLoadingUsers(false);
        return response.data;
      } catch (e) {
        console.log(e);
        setLoadingUsers(false);
        setErrorMessage(e.message);
      }
    },
    []
  );

  const getVendorsCOItag = useCallback(async (companyId: string) => {
    try {
      setLoadingUsers(true);
      const response = await API.get(`Procore/GetVendorCOITag?CompanyID=${companyId}`);
      setLoadingUsers(true);
      return response.data;
    } catch (e) {
      console.log(e);
      setLoadingUsers(false);
      setErrorMessage(e.message);
    }
  }, []);

  const getAdditionalContacts = useCallback(async (jonesId: string, insuranceRequestId: number) => {
    try {
      setLoadingContacts(true);
      let companyId = new URLSearchParams(window.location.search).get(
        "CompanyID"
      );
      const response = await API.get(`Procore/GetAdditionalContacts?jonesId=${jonesId}&CompanyID=${companyId}`);

      setCoiContact({
        ...response.data,
        insuranceRequestId: insuranceRequestId,
      });
      setOriginalCoiContact(response.data);
    } catch (e) {
      console.log(e);
      
      setErrorMessage(e.message);
    }
    setLoadingContacts(false);
  }, []);


  const onUpdateAdditionalContacts = useCallback(async (coiContact: CoiContact) => {
    try {
      setSubmittingContacts(true)
      let companyId = new URLSearchParams(window.location.search).get(
        "CompanyID"
      );
      const response = await API.post(
        `Procore/UpdateAdditionalContacts?companyId=${companyId}`,
        coiContact
      );

      if (response.data === true) {
        showSuccessMessage(
          "Contacts have been updated successfully...!",
          <SuccessIcon />
        );
      } else {
        showErrorMessage("Failed to update the contacts");
      }
      setSubmittingContacts(false)
      return response.data;
    } catch (e) {
      console.log(e);
      setErrorMessage(e.message);
      setSubmittingContacts(false)
    }
  }, []);

  const onLoadCoiFiles = useCallback(
    async (ForeignId2: string, Id: any) => {

      try {

        setLoadingUsers(true);
        const response = await API.get(
          `Procore/GetRecentCoiFile?ForeignId2=${ForeignId2}&Id=${Id}`,
        );
        if (response && response.data) {
          return response.data;
        }
        else { return null; }

      } catch (e) {
        console.log(e);

        setErrorMessage(e.message);
      }
    },
    []
  );


  const onUploadCoiFiles = useCallback(
    async (values, ForeignId2: string, Id: any) => {      
      setCoifileload(true)
      try {
        

        let formData = new FormData();
        for (var i = 0; i < values.length; i++) {
          const element = values[i].file;
          formData.append(`files`, element);
        }
        const response = await API.post(
          `Procore/UploadCoiFile?ForeignId2=${ForeignId2}&Id=${Id}`, formData
        );
        onLoadJonesVendors();
        onLoadGlobalJonesVendors();
        setCoifileload(false)
        
        
        if (response.data == true) {     

          showSuccessMessage(
            "Insurance docs have been uploaded",
            <SuccessIcon />
          );
         } else {
          showErrorMessage("File is incorrect");
        }
        return response.data;
      } catch (e) {
        console.log(e);
        setLoadingUsers(false);
        setErrorMessage(e.message);
      }
    },
    []
  );


  const onLoadJonesVendors = useCallback(
    async (search: string = '') => {
      setLoadingJonesVendors(true);
      try {
        const projectId = new URLSearchParams(window.location.search).get("ProjectID");
        let companyId = new URLSearchParams(window.location.search).get("CompanyID");
        const response = await API.get(`Procore/GetJonesVendors?projectId=${projectId}&CompanyId=${companyId?.toString()}&search=${search}`);
        setJonesVendor(response.data);
        setLoadingJonesVendors(false);
        return response.data;

      } catch (e) {
        setLoadingJonesVendors(false);
      }
    }, []
  )

  const onLoadGlobalisexist = useCallback(
    async (search: string = '') => {
      setLoadingJonesVendors(true);
      try {
        let companyId = new URLSearchParams(window.location.search).get(
          "CompanyID"
        );
        const response = await API.get(`Procore/Globalisexist?CompanyID=${companyId?.toString()}`);
       
        setLoadingJonesVendors(false);
        setisGlobalexits(response.data);

      } catch (e) {
        setLoadingJonesVendors(false);
      }
    }, []
    )

    const onLoadGlobalViewEnable = useCallback(
        async () => {
            setLoadingJonesVendors(true);
            try {
                let companyId = new URLSearchParams(window.location.search).get(
                    "CompanyID"
                );
                const response = await API.get(`Procore/GlobalViewEnable?CompanyID=${companyId?.toString()}`);
                setIsGlobalViewEnable(response.data);
                setLoadingJonesVendors(false);
            } catch (e) {
                setLoadingJonesVendors(false);
            }
        }, []
    )

  const onLoadGlobalJonesVendors = useCallback(
    async (search: string = '') => {
      setLoadingGlobalJonesVendors(true);
      try {
        const projectId = new URLSearchParams(window.location.search).get("ProjectID");
        let companyId = new URLSearchParams(window.location.search).get("CompanyID");
        const response = await API.get(`Procore/GetGlobalJonesVendors?projectId=${projectId}&compnayId=${companyId?.toString()}&search=${search}`);
        setJonesGlobalVendor(response.data);
        setLoadingGlobalJonesVendors(false);
        return response.data;

      } catch (e) {
        setLoadingGlobalJonesVendors(false);
      }
    }, []
  )

  const onDownLoadFile = React.useCallback(async (search) => {
    setDownLoading(true);
    const projectId = new URLSearchParams(window.location.search).get("ProjectID");
    const companyId = new URLSearchParams(window.location.search).get("CompanyID");

    try {
      const { data, headers } = await API.get(
        `Procore/DownloadJonesVendors?projectId=${projectId}&compnayId=${companyId?.toString()}&search=${search}`,
        {
          responseType: 'blob',
        }
      );
      fileDownload(data, headers.filename);
      setDownLoading(false);
    } catch (e) {
      setDownLoading(false);
      showErrorMessage('Failed to download file');
    }
  }, []);

  const onLoadPermissions = React.useCallback(async () => {
    let companyId = new URLSearchParams(window.location.search).get(
      "CompanyID"
    );
    let projectId = new URLSearchParams(window.location.search).get(
      "ProjectID"
    );
    try {
      const response = await API.get(`Procore/GetPermissionTemplates?companyId=${companyId?.toString()}&projectId=${projectId}`);
      if (response.data) {
        setPermissions([
          {
            label: "",
            options: [
              {
                id: 0,
                type: "",
                name: "Apply Permission Template Later",
                projectSpecific: false
              }
            ]
          },
          ...response.data
        ])
      }
    } catch (error) {
      console.log(error);
    }
  }, [])

  const onLoadAccountSettingDetails = useCallback(async () => {
    try {
      setLoadingContacts(true);
      let companyId = new URLSearchParams(window.location.search).get(
        "CompanyID"
      );
      const response = await API.get(`Procore/GetAccountSettingDetails?CompanyID=${companyId}`);

      setInsuranceSetting(response.data);
    } catch (e) {
      console.log(e);
      
    }
    setLoadingContacts(false);
  }, []);

  useEffect(() => {
    onLoadAccountSettingDetails();
  }, [ onLoadAccountSettingDetails])

  return {
    project,
    insurance,
    loading,
    setInsurance,
    errorMessage,
    jonesVendor,
    jonesGlobalVendor,
    onLoadJonesVendors,
    onLoadGlobalJonesVendors,
    downloading,
    onDownLoadFile,
    onLoadVendorsUsers,
    getVendorsCOItag,
    loadingUsers,
    setLoadingUsers,
    onLoadProject,
    loadingJonesVendors,
    loadingGlobalJonesVendors,
    permissions,
    onLoadCoiFiles,
    onUploadCoiFiles,
    Coifileload,
    onLoadGlobalisexist,
    isGlobalexits,
    onLoadGlobalViewEnable,
    isGlobalViewEnable,
    JonesPermission,
    coiContact, 
    setCoiContact,
    getAdditionalContacts,
    onUpdateAdditionalContacts,
    submittingContacts,
    originalCoiContact,setOriginalCoiContact,
    loadingContacts,
    insuranceSetting

  }
}

export function useStore() {
  const [submitting, setSubmitting] = useState<boolean>(false);
 

  const onStore = useCallback(
    async (values) => {
      try {

        setSubmitting(true);
        let data = new FormData();
        data.append('projectId', values.projectId.toString());
        data.append('clientId', values.clientId);
        data.append('requirementId', values.requirementId);
        data.append('kriyagoProjectId', values.kriyagoProjectId);
        data.append('companyId', values.companyId?.toString());
        data.append('tabId', values.tabId);
        if (values?.vendors && values.vendors.length) {
          values.vendors.forEach((v: any, idx: any) => {
            data.append(`vendors[${idx}].id`, v.id);
            data.append(`vendors[${idx}].code`, v.code ?? null);
            data.append(`vendors[${idx}].name`, v.name ?? null);
            data.append(`vendors[${idx}].emailAddress`, v.emailAddress ?? null);
            data.append(`vendors[${idx}].contactName`, v.contactName ?? null);
            data.append(`vendors[${idx}].coiContactUserId`, v.coiContactUserId ?? 0);
            data.append(`vendors[${idx}].isRequestSent`, v.isRequestSent);
            if (v.contactCoiUser) {
              data.append(`vendors[${idx}].contactCoiUser.id`, v.contactCoiUser?.id);
              data.append(`vendors[${idx}].contactCoiUser.name`, v.contactCoiUser?.name);
              data.append(`vendors[${idx}].contactCoiUser.emailAddress`, v.contactCoiUser?.emailAddress);
              data.append(`vendors[${idx}].contactCoiUser.lastName`, v.contactCoiUser?.lastName);
              data.append(`vendors[${idx}].contactCoiUser.permissionTemplateId`, v.contactCoiUser?.permissionTemplateId);
            }
            if (v.isRequestCoi !== null) {
              data.append(`vendors[${idx}].isRequestCoi`, v.isRequestCoi);
            }

            if (v.coiFiles && v.coiFiles.length) {
              for (let idx2 = 0; idx2 < v.coiFiles.length; idx2++) {
                const element = v.coiFiles[idx2].file;
                data.append(`vendors[${idx}].files`, element);

              }
            }
          });
        }
        const response = await API.post("Procore/InviteVendorInsReq", data);
        sessionStorage.setItem('FailedCoiResponse', JSON.stringify(response.data));
       
       setSubmitting(false);
        if (response) {
          if (Array.isArray(response.data) && response.data.length === 0) {
            showSuccessMessage(
              "Great, a request has been sent! Status will be shown on the company’s insurance tab on the directory tool",
              <SuccessIcon />
            );
          } else {
            // Handle other cases when response.data is not an empty array
          }
        } else {
          showErrorMessage("Submission failed");
        }
      } catch (e) {
        console.log(e);
        setSubmitting(false);
        showErrorMessage(e?.response?.data);
      }
    },
    [setSubmitting]
  );
  return { onStore, submitting };
}
